import { render } from "./SoundSheetsHost.vue?vue&type=template&id=740d3369"
import script from "./SoundSheetsHost.vue?vue&type=script&lang=js"
export * from "./SoundSheetsHost.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__